import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';

export default function AirportLookup() {
  const [airportSearch, setAirportSearch] = useState('');
  const [airportResults, setAirportResults] = useState([]);
  const [allAirports, setAllAirports] = useState([]);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/airports.csv')
      .then(res => res.text())
      .then(text => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            setAllAirports(results.data);
          }
        });
      });
  }, []);

  useEffect(() => {
    if (!airportSearch || allAirports.length === 0) {
      setAirportResults([]);
      return;
    }
    const q = airportSearch.toLowerCase();
    setAirportResults(
      allAirports.filter(a =>
        (a.name && a.name.toLowerCase().includes(q)) ||
        (a.icao_code && a.icao_code.toLowerCase().includes(q)) ||
        (a.iata_code && a.iata_code.toLowerCase().includes(q)) ||
        (a.municipality && a.municipality.toLowerCase().includes(q))
      ).slice(0, 20)
    );
  }, [airportSearch, allAirports]);

  return (
    <div style={{ maxWidth: 700, margin: '3rem auto', background: '#181a2a', borderRadius: 16, padding: '2.5rem 2rem', color: 'white', boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
      <div style={{ marginBottom: '2rem', background: '#23243a', borderRadius: 12, padding: '1.2rem' }}>
        <h3 style={{ color: '#b6eaff', marginBottom: '0.7rem', fontSize: '1.2rem' }}>Airport Search (Europe CSV)</h3>
        <input
          type="text"
          value={airportSearch}
          onChange={e => setAirportSearch(e.target.value)}
          placeholder="Search airport name, ICAO, IATA, or city..."
          style={{ width: '100%', padding: '0.6rem 1rem', margin: '0.3rem 0', borderRadius: '6px', border: '1px solid #1ecfff', background: '#23243a', color: 'white', fontSize: '1rem', outline: 'none', boxSizing: 'border-box', marginBottom: 0 }}
        />
        {airportResults.length > 0 && (
          <div style={{ marginTop: 12, maxHeight: 260, overflowY: 'auto', background: '#181a2a', borderRadius: 8, boxShadow: '0 2px 8px rgba(30,207,255,0.10)' }}>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
              {airportResults.map((a, idx) => (
                <li key={a.id || idx} style={{ padding: '0.7rem 1rem', borderBottom: '1px solid #23243a', color: '#b6eaff' }}>
                  <strong>{a.name}</strong> {a.icao_code && <>({a.icao_code})</>} {a.iata_code && <>[{a.iata_code}]</>}
                  <br />
                  <span style={{ fontSize: '0.95em', color: '#1ecfff' }}>{a.municipality}</span>
                  {a.latitude_deg && a.longitude_deg && (
                    <span style={{ marginLeft: 12, color: '#b6eaff' }}>Lat: {a.latitude_deg}, Lng: {a.longitude_deg}</span>
                  )}
                  {a.type && <span style={{ marginLeft: 12, color: '#b6eaff' }}>{a.type.replace('_', ' ')}</span>}
                </li>
              ))}
            </ul>
          </div>
        )}
        {airportSearch && airportResults.length === 0 && (
          <div style={{ marginTop: 12, color: '#ff6b6b' }}>No results found.</div>
        )}
      </div>
    </div>
  );
}
